module.exports = __webpack_public_path__ + "static/media/Ekspedisi Indonesia Baru.e2eda18b.png";